import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { media } from 'components/utils/breakpoints'

export const Container = styled(Box)`
    width: 100%;
    max-width: ${(props: any) => (props.open ? '240px' : '72px')};
    height: 100vh;
    display: flex;
    flex-direction: column;
    border-radius: 0 1rem 1rem 0;
    padding: 0 var(--chakra-space-4);
    transition: 0.3s;

    @media ${media('lg', 'max')} {
        position: ${(props: any) => props.open && 'absolute'};

        &::after {
            content: '';
            width: ${(props: any) => (props.open ? '100%' : '0px')};
            height: 100%;
            opacity: ${(props: any) => (props.open ? '1' : '0')};
            position: fixed;
            inset: 0;
            background: var(--chakra-colors-blackAlpha-600);
            z-index: -1;
            transition: opacity 0.3s;
        }
    }
`

export const SidebarHeader = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: ${(props: any) => (props.open ? 'flex-end' : 'center')};
    padding: var(--chakra-space-2) 0;

    svg {
        cursor: pointer;
    }
`

export const SidebarBody = styled(Box)`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;
`